export default {"src":"/_next/static/media/excel-sheet.bb1ded75.svg","height":24,"width":24};